<form [formGroup]="formGroup" id="step3Form">
  <div class="step3-form-container">
    <div class="row">
      @if (controls.wasSentencedInPoland; as wasSentencedInPoland) {
        <div class="standard-form-field radio-form-field wasSentencedInPoland-field required-field">
          <label
            id="applicantWasSentencedInPolandLabel"
            [class.invalid]="wasSentencedInPoland.touched && wasSentencedInPoland.invalid">
            {{ 'PERSONAL_DATA_FORM.WAS-SENTENCED-IN-POLAND.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="applicantWasSentencedInPolandInput"
            formControlName="wasSentencedInPoland"
            [attr.aria-labelledby]="'applicantWasSentencedInPolandLabel'"
            [attr.aria-invalid]="wasSentencedInPoland.touched && wasSentencedInPoland.invalid ? 'true' : null"
            (keydown)="firstInputKeydown($event)"
            [required]="true">
            <mat-radio-button [value]="true" id="applicantWasSentencedInPoland-0">
              {{ 'COMMON.GENERAL.YES' | translate }}
            </mat-radio-button>
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      }
      @if (controls.wasSentencedInPoland.value === true) {
        @if (controls.sentenceReason; as sentenceReason) {
          <div class="standard-form-field full-width-field sentenceReason-field" aria-live="polite">
            <label
              for="applicantSentenceReasonInput"
              [class.invalid]="sentenceReason.touched && sentenceReason.invalid">
              {{ 'PERSONAL_DATA_FORM.SENTENCE-REASON.MAIN-LABEL' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <textarea
                matInput
                id="applicantSentenceReasonInput"
                formControlName="sentenceReason"
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="9"></textarea>
              <!-- ERROR -->
              @if (sentenceReason.touched && sentenceReason.invalid) {
                <mat-error id="applicantSentenceReasonError">
                  {{ sentenceReason.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      }
    </div>
    <div class="row">
      @if (controls.currentlySubjectOfProceedings; as currentlySubjectOfProceedings) {
        <div class="standard-form-field radio-form-field currentlySubjectOfProceedings-field required-field">
          <label
            id="applicantCurrentlySubjectOfProceedingsLabel"
            [class.invalid]="currentlySubjectOfProceedings.touched && currentlySubjectOfProceedings.invalid">
            {{ 'PERSONAL_DATA_FORM.CURRENTLY-SUBJECT-OF-PROCEEDINGS.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="applicantCurrentlySubjectOfProceedingsInput"
            formControlName="currentlySubjectOfProceedings"
            [attr.aria-labelledby]="'applicantCurrentlySubjectOfProceedingsLabel'"
            [attr.aria-invalid]="
              currentlySubjectOfProceedings.touched && currentlySubjectOfProceedings.invalid ? 'true' : null
            "
            [required]="true">
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      }
      @if (controls.currentlySubjectOfProceedings.value === true) {
        @if (controls.proceedingsReason; as proceedingsReason) {
          <div class="standard-form-field full-width-field proceedingsReason-field" aria-live="polite">
            <label
              for="applicantProceedingsReasonInput"
              [class.invalid]="proceedingsReason.touched && proceedingsReason.invalid">
              {{ 'PERSONAL_DATA_FORM.PROCEEDINGS-REASON.MAIN-LABEL' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <textarea
                matInput
                id="applicantProceedingsReasonInput"
                formControlName="proceedingsReason"
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="9"></textarea>
              <!-- ERROR -->
              @if (proceedingsReason.touched && proceedingsReason.invalid) {
                <mat-error id="applicantProceedingsReasonError">
                  {{ proceedingsReason.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      }
    </div>
    <div class="row">
      @if (controls.liabilitiesFromVerdicts; as liabilitiesFromVerdicts) {
        <div class="standard-form-field radio-form-field liabilitiesFromVerdicts-field required-field">
          <label
            id="applicantLiabilitiesFromVerdictsLabel"
            [class.invalid]="liabilitiesFromVerdicts.touched && liabilitiesFromVerdicts.invalid">
            {{ 'PERSONAL_DATA_FORM.LIABILITIES-FROM-VERDICTS.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="applicantLiabilitiesFromVerdictsInput"
            formControlName="liabilitiesFromVerdicts"
            (keydown.Tab)="liabilitiesFromVerdicts.value !== true ? emitLastFieldTabPressed($event) : undefined"
            [attr.aria-labelledby]="'applicantLiabilitiesFromVerdictsLabel'"
            [attr.aria-invalid]="liabilitiesFromVerdicts.touched && liabilitiesFromVerdicts.invalid ? 'true' : null"
            [required]="true">
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      }
      @if (controls.liabilitiesFromVerdicts.value === true) {
        @if (controls.liabilitiesDescription; as liabilitiesDescription) {
          <div class="standard-form-field full-width-field liabilitiesDescription-field" aria-live="polite">
            <label
              for="applicantLiabilitiesDescriptionInput"
              [class.invalid]="liabilitiesDescription.touched && liabilitiesDescription.invalid">
              {{ 'PERSONAL_DATA_FORM.LIABILITIES-DESCRIPTION.MAIN-LABEL' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <textarea
                matInput
                (keydown.Tab)="emitLastFieldTabPressed($event)"
                id="applicantLiabilitiesDescriptionInput"
                formControlName="liabilitiesDescription"
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="9"></textarea>
              <!-- ERROR -->
              @if (liabilitiesDescription.touched && liabilitiesDescription.invalid) {
                <mat-error id="applicantLiabilitiesDescriptionError">
                  {{ liabilitiesDescription.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      }
    </div>
  </div>
</form>
